<template>
  <ui-box class="ui-box-apply" bgType="light">
    <template v-slot:nav-left>
      <ui-tag class="title">
        <i></i>
        <div class="label-box">
          <span class="label-shadow">战队简介</span>
          <span class="label-text">战队简介</span>
        </div>
      </ui-tag>
    </template>
    <template v-slot:nav-right>
      <div class="right-box">
        <button class="btn-exit" @click="handleExit"></button>
      </div>
    </template>
    <template v-slot:container>
      <div class="inner-container">
        <div class="scroll-box">
          <div class="info-box">
            <div class="row">
              <input type="text" v-model="team.name" placeholder="战队名称(限制7个字)">
            </div>
            <div class="row">
              <textarea v-model="team.intro" placeholder="战队简介"></textarea>
            </div>
            <div class="row">
              <textarea v-model="team.player_intro" placeholder="队员介绍"></textarea>
            </div>
          </div>
        </div>
        <div class="bottom-box">
          <div class="bg"></div>
          <div class="decorate"></div>
          <ui-frame-bg class="btn prev" colorType="blue" @click.native="prev">
            <div class="label-box">
              <span class="label-shadow">上一项</span>
              <span class="label-text">上一项</span>
            </div>
          </ui-frame-bg>
          <ui-frame-bg class="btn submit" colorType="yellow" @click.native="submit">
            <div class="label-box">
              <span class="label-shadow">确认</span>
              <span class="label-text">确认</span>
            </div>
          </ui-frame-bg>
        </div>
      </div>
    </template>
  </ui-box>
</template>

<script>
import UiBox from '@/components/ui-box';
import UiTag from '@/components/ui-tag';
import UiFrameBg from '@/components/ui-frame-bg';

export default {
  components: { UiBox, UiTag, UiFrameBg },
  inject: ['handleStepSubmit', 'handleStep', 'promptMsg'],
  data() {
    return {
      team: {
        name: '',
        intro: '',
        player_intro: ''
      }
    }
  },
  methods: {
    prev() {
      this.handleStep(3)
    },
    validInfo() {
      let valid = true;
      if(!this.team['name']) {
        valid = false;
        this.promptMsg('请填写战队名称')
      }else if(!this.team['intro']) {
        valid = false;
        this.promptMsg('请填写战队简介')
      }else if(!this.team['player_intro']) {
        valid = false;
        this.promptMsg('请填写队员介绍')
      }

      return valid;
    },
    submit() {
      let valid = this.validInfo();
      if(valid) {
        this.handleStepSubmit(4, this.team);
      }
    },
    handleExit() {
      this.$emit('confirm')
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  font-weight: 500;
  i {
    position: relative;
    @include sizeSet($width: 36px, $height: 36px);
    @include icon_status('info_2', $hook: 'all');
    margin-right: get_vh(8px);
  }
  .label-box {
    .label-shadow {
      color: #FFFFFF;
    }
    .label-text {
      color: #133469;
    }
  }
}

.right-box {
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  height: 100%;
  .btn-exit {
    @include sizeSet($width: 92px, $height: 44px);
    background-image: $bg_btn;
    background-size: get_vh(786px) get_vh(384px);
    background-position: get_vh(-13px) get_vh(-212px);
    background-repeat: no-repeat;
    @include marginSet($marginTop: 4px);
    @include boxShadowSet_Btn;
    @media screen and (max-aspect-ratio: 3/2) {
      background-size: get_vw(786px) get_vw(384px);
      background-position: get_vw(-13px) get_vw(-212px);
    }
  }
}

.inner-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 0px 0px get_vh(20px) get_vh(20px);
  overflow: hidden;
  .scroll-box {
    flex: 1;
    width: 98.5%;
    margin: 0 auto;
    overflow-y: scroll;
    overflow-x: hidden;
    margin-top: get_vh(27px);
    padding-bottom: get_vh(50px);
    .info-box {
      width: get_vw(822px);
      margin: 0 auto;
      overflow: hidden;
      .row {
        width: 100%;
        margin-bottom: get_vh(19px);
        input, textarea {
          border: get_vh(2px) solid #CCCCCC;
          border-radius: get_vh(10px);
          font-size: get_vh(20px);
          color: #333;
          padding-left: get_vw(25px);
          outline: none;

          @media screen and (max-aspect-ratio: 3 / 2) {
            font-size: get_vh(18px);
          }
        }
        ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
          color: #CCCCCC;
          opacity: 1; /* Firefox */
        }
        :-ms-input-placeholder { /* Internet Explorer 10-11 */
          color: #CCCCCC;
        }
        ::-ms-input-placeholder { /* Microsoft Edge */
          color: #CCCCCC;
        }

        input {
          width: get_vw(350px);
          height: get_vw(64px);
        }
        textarea {
          width: get_vw(790px);
          height: get_vw(120px);
          padding-top: get_vw(24px);
          resize: none;
        }
      }
    }
  }
  .bottom-box {
    position: relative;
    width: 100%;
    height: get_vh(124px);
    display: flex;
    justify-content: space-between;
    align-items: center;
    .decorate {
      position: absolute;
      bottom: get_vh(-80px);
      right: get_vh(360px);;
      width: get_vh(164px);
      height: get_vh(167px);
      background-image: $bg_decorate;
      background-size: get_vh(1472px) get_vh(639px);
      background-position: get_vh(-574px) get_vh(-104px);
      background-repeat: no-repeat;
    }
    .bg {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: get_vh(180px);
      background-image: $bg_bottom;
      background-size: 100% 100%;
      background-position: center top;
      background-repeat: no-repeat;
    }
    .btn {
      position: relative;
      width: get_vh(266px);
      height: get_vh(70px);
      font-size: get_vh(28px);
      font-weight: bold;
      @include boxShadowSet_Btn;
      cursor: pointer;
      -webkit-tap-highlight-color: transparent;
      &:active {
        opacity: 0.9;
      }

      &.prev {
        margin-left: get_vh(42px);
      }
      &.submit {
        margin-right: get_vh(42px);
      }
    }
  }
}
</style>